import type { CategoryContent } from './row.js';

export const DANISH_HISTORY: CategoryContent = {
  bscba: [
    [
      'What is the name of the personal union that linked Denmark, Norway, and Sweden from 1397 to 1523?',
      [
        'The Kalmar Union',
        'The Hansa Union',
        'The Northern Confederation',
        'The Scandinavian Treaty',
      ],
      0,
      'The Kalmar Union united Denmark, Norway, and Sweden under a single monarch. Sweden exited in 1523.',
    ],
    [
      'Which Danish king conquered England and Norway, establishing a North Sea empire in the early 11th century?',
      [
        'Canute II',
        'Harold Bluetooth',
        'Sweyn Forkbeard',
        'Christian IV',
      ],
      0,
      'Canute II (ruled 1019–1035) conquered England and Norway, creating a short-lived North Sea empire.',
    ],
    [
      'In what year did Denmark adopt Lutheranism and officially break with the Roman Catholic Church?',
      [
        '1536',
        '1517',
        '1534',
        '1545',
      ],
      0,
      'Denmark adopted Lutheranism in 1536 under King Christian III, severing ties to Rome.',
    ],
    [
      'Which conflict in 1864 resulted in Denmark losing Schleswig and Holstein to Prussia?',
      [
        'The Second Schleswig War',
        'The Great Nordic War',
        'The Thirty Years\' War',
        'The Holstein Uprising',
      ],
      0,
      'The Second Schleswig War (1864) ended in Danish defeat, ceding Schleswig and Holstein to Prussia.',
    ],
    [
      'Why did Denmark lose Norway to Sweden under the Treaty of Kiel in 1814?',
      [
        'Denmark had backed Napoleon in the wars',
        'Norway\'s population demanded immediate independence',
        'A naval battle gave Sweden control',
        'The Storting rejected the treaty entirely',
      ],
      0,
      'Denmark backed Napoleon, so the 1814 Treaty of Kiel transferred Norway to Sweden as punishment.',
    ],
    [
      'Which Danish king established absolute monarchy in 1660 by enacting the Royal Law?',
      [
        'Frederick III',
        'Christian IV',
        'Christian VI',
        'Frederick V',
      ],
      0,
      'Frederick III implemented the Kongelov (Royal Law) in 1660, replacing elective with absolute rule.',
    ],
    [
      'What major late-18th-century reform improved peasant conditions by consolidating fragmented land holdings?',
      [
        'Estate Consolidation',
        'The Peasant Revolt',
        'The Enclosure Movement',
        'The Agricultural Revolution',
      ],
      0,
      '1770s–1780s reforms consolidated peasant lands and reduced serfdom, modernizing rural agriculture.',
    ],
    [
      'In what year was Denmark\'s first constitutional monarchy established?',
      [
        '1849',
        '1848',
        '1864',
        '1901',
      ],
      0,
      'The 1849 Constitution established constitutional monarchy and a bicameral parliament.',
    ],
    [
      'Which Danish scientist won the Nobel Prize in Physics for contributions to atomic theory?',
      [
        'Niels Bohr',
        'Hendrik Lorentz',
        'Max Planck',
        'Albert Einstein',
      ],
      0,
      'Niels Bohr won the Nobel Prize for his atomic model and quantum contributions.',
    ],
    [
      'What was Denmark\'s primary status during World War II (1940–1945)?',
      [
        'Occupied by Nazi Germany',
        'An active Nazi ally throughout the war',
        'Neutral and never occupied',
        'A member of the Allied forces',
      ],
      0,
      'Germany invaded Denmark in April 1940. Denmark remained occupied until May 1945, though civilian Danish administration continued under Nazi oversight.',
    ],
    [
      'What is the name of Denmark\'s primary legislative body, established in 1849?',
      [
        'The Folketing',
        'The Rigsråd',
        'The Rigsdagog',
        'The Landsting',
      ],
      0,
      'The Folketing (people\'s assembly) has been Denmark\'s main legislative body since 1849.',
    ],
    [
      'Which Danish philosopher is best known for existentialist writings and critique of institutional Christianity?',
      [
        'Søren Kierkegaard',
        'Georg Wilhelm Hegel',
        'Bertrand Russell',
        'Ludwig Wittgenstein',
      ],
      0,
      'Søren Kierkegaard pioneered existentialist philosophy and critiqued institutional Christianity.',
    ],
    [
      'What was the primary economic foundation of medieval Denmark?',
      [
        'Trade, fishing, and farming',
        'Mining and precious metals',
        'Manufacturing and textiles',
        'Colonial ventures in the Americas',
      ],
      0,
      'Medieval Denmark relied on Baltic trade, fishing, and agriculture. The Øresund Strait toll brought wealth.',
    ],
    [
      'In what year did Denmark transition from a bicameral to a unicameral parliament?',
      [
        '1953',
        '1901',
        '1849',
        '1939',
      ],
      0,
      'Denmark\'s 1953 Constitution created a unicameral Folketing, eliminating the upper house.',
    ],
    [
      'Which Nordic dynasty ruled Denmark from 1448 through the modern era?',
      [
        'The House of Oldenburg',
        'The House of Glücksburg',
        'The House of Estridsson',
        'The House of Gottorp',
      ],
      0,
      'The Oldenburg dynasty ruled Denmark from 1448 onward, including through the modern period.',
    ],
  ],
  msc: [
    [
      'What was the primary territorial consequence of the Treaty of Roskilde (1658) for Denmark?',
      [
        'Lost Scania, Blekinge, and Halland to Sweden',
        'Denmark regained Norway from Swedish control',
        'Denmark acquired Schleswig-Holstein in exchange',
        'Denmark established North Sea naval dominance',
      ],
      0,
      'The Treaty of Roskilde (1658) transferred Scania, Blekinge, and Halland to Sweden, altering Baltic geopolitics.',
    ],
    [
      'Which legal doctrine formalized in 1660 subordinated the Danish nobility to the crown?',
      [
        'The Kongelov (Royal Law)',
        'The Danske Lov (Danish Law)',
        'The Grundloven (Constitution)',
        'The Privilegium Sigismundi',
      ],
      0,
      'The Kongelov (1660) established absolute monarchy by concentrating power and eliminating noble veto.',
    ],
    [
      'How did Denmark\'s control of the Øresund Strait function as a mercantilist revenue source?',
      [
        'Toll collection on passing shipping',
        'Direct African colonial trade',
        'Heavy domestic manufacturing exports',
        'Enforcement of Navigation Acts',
      ],
      0,
      'Denmark monetized the Øresund Strait through tolls. This revenue made Denmark a major fiscal power.',
    ],
    [
      'Which 1770s–1780s reform abolished peasant serfdom and encouraged freehold land ownership?',
      [
        'Stavnsbånd abolition',
        'The Reformatio Sigismundi',
        'The Marriage and Inheritance Law',
        'The Guild Ordinance',
      ],
      0,
      'The 1770s–1780s reforms abolished serfdom and consolidated peasant holdings, transforming rural society.',
    ],
    [
      'How did the Grundtvig movement reshape Danish educational culture and popular nationalism?',
      [
        'Folk schools and vernacular culture',
        'It imported German university models',
        'It restricted education to nobility and clergy',
        'It adopted Prussian military academies',
      ],
      0,
      'Grundtvig promoted folk schools emphasizing Danish language and history—foundational to Danish identity.',
    ],
    [
      'What political shift did the 1901 parliamentary reform enable in Danish electoral politics?',
      [
        'Extension of suffrage to rural smallholders',
        'Complete abolition of local government',
        'Immediate adoption of proportional representation',
        'Transfer of parliament to the monarchy',
      ],
      0,
      'The 1901 reform extended suffrage to rural smallholders, enabling Venstre agrarian dominance.',
    ],
    [
      'Which Nordic diplomatic crisis in the early 20th century prompted Denmark\'s strategic shift toward neutrality?',
      [
        'Sweden–Norway split (1905)',
        'The Russo-Japanese War',
        'The Boer War',
        'The Irish independence movement',
      ],
      0,
      'Sweden–Norway\'s 1905 split and Prussian militarism pushed Denmark toward neutrality.',
    ],
    [
      'What characterized Denmark\'s "Cooperation Policy" (Samarbejdspolitikken) during Nazi occupation?',
      [
        'Civilian government retained',
        'Complete resistance and government-in-exile',
        'Immediate declaration of war on Germany',
        'Never formally occupied',
      ],
      0,
      'Denmark\'s cooperation policy allowed civilian administration under occupation. Historiography debates collaboration.',
    ],
    [
      'How did the Great Depression era Kanslergade Agreement (1933) between Venstre and Social Democrats reshape governance?',
      [
        'Coalition for public works',
        'It abolished democratic institutions',
        'It privatized all state enterprises',
        'It introduced strict austerity',
      ],
      0,
      'The 1933 Kanslergade Agreement united agrarian and labor parties, funding public works. It presaged the Nordic model.',
    ],
    [
      'How did postwar negotiations shape Denmark\'s territorial and geopolitical settlement after 1945?',
      [
        'Schleswig back, NATO joined',
        'They dissolved the monarchy',
        'They accepted Soviet occupation',
        'They rejected all reparations',
      ],
      0,
      'Post-1945 negotiations restored North Schleswig to Denmark. Denmark joined NATO (1949).',
    ],
    [
      'What historiographical debate surrounds Danish economic "collaboration" versus "pragmatic neutrality" during WWII occupation?',
      [
        'Food exports to Germany: war crime or necessity',
        'Complete consensus exists on Denmark\'s innocence',
        'No historical records exist of any trade',
        'Denmark openly declared itself part of Nazi state',
      ],
      0,
      'Historians debate whether Danish food exports to Nazi Germany constituted collaboration or coerced pragmatism.',
    ],
    [
      'How did Margrethe I (ruled 1353–1412) consolidate Scandinavian political unity?',
      [
        'Through inheritance and diplomacy',
        'She abolished the monarchy',
        'She ceded Denmark to Germany',
        'She converted Denmark to Catholicism',
      ],
      0,
      'Margrethe I unified Scandinavia through inheritance and diplomacy. The 1397 Kalmar Union formalized her achievement.',
    ],
    [
      'How did the 1849 Constitution differ from the 1863 constitutional amendment?',
      [
        '1849 Grundloven was more liberal',
        'Both were identical',
        'The 1863 version abolished monarchy',
        'The 1849 version had no parliament',
      ],
      0,
      'The 1849 Constitution was more democratic. The 1863 revision restricted suffrage and empowered conservatives.',
    ],
    [
      'What geopolitical transition did the British blockade (1807–1814) and loss of Norway represent?',
      [
        'The end of Denmark as a major power',
        'Denmark\'s consolidation of Mediterranean influence',
        'An increase in French support',
        'Denmark\'s acquisition of British colonies',
      ],
      0,
      'Backing Napoleon led to blockade and Norwegian loss. Denmark declined from regional power to smaller Nordic state.',
    ],
    [
      'Which 18th-century figure\'s reform initiatives (1770–1772) challenged feudal privilege before a conservative coup?',
      [
        'Struensee',
        'Frederick III',
        'Christian VI',
        'Ove Høgh-Guldberg',
      ],
      0,
      'Struensee\'s agrarian and legal reforms threatened nobility. A coup executed him and reversed reforms.',
    ],
  ],
  phd: [
    [
      'How did abolition of stavnsbåndet (1788) and land consolidation reforms (1770s–1780s) fundamentally alter Danish agrarian social structure?',
      [
        'Freehold ownership and wage-labor split',
        'They maintained feudal obligations indefinitely',
        'They instantly created an industrial working class',
        'They exported the entire peasantry to Russia',
      ],
      0,
      'Abolishing stavnsbåndet and consolidating lands created freehold farmers and landless laborers. This enabled agrarian capitalism.',
    ],
    [
      'How did declining Øresund toll revenues (1600s–1700s) precipitate the fiscal crisis that justified absolute monarchy?',
      [
        'Tolls fell, absolutism followed',
        'Toll revenue increased indefinitely',
        'Denmark never relied on toll income',
        'Toll decline strengthened democracy',
      ],
      0,
      'Declining tolls created fiscal pressure. Frederick III\'s absolutism (1660) centralized wealth extraction.',
    ],
    [
      'How did the Struensee era (1770–1772) embody Enlightenment reform conflicts, and why did agrarian interests provoke backlash?',
      [
        'Threatened noble privilege',
        'He was universally praised',
        'The reforms had no impact',
        'Struensee strengthened the nobility',
      ],
      0,
      'Struensee\'s agrarian reforms challenged feudalism. Nobles orchestrated his execution and coup in 1772.',
    ],
    [
      'How did the Napoleonic Wars reshape Denmark\'s strategic interests and long-term alignment?',
      [
        'Ended great-power status, liberal pivot',
        'Denmark benefited immensely from Napoleonic alliances',
        'Denmark switched to the German side immediately',
        'The wars had no impact on strategy',
      ],
      0,
      'Napoleonic backing led to blockade and Norwegian loss. Denmark pivoted toward constitutionalism and Westernization.',
    ],
    [
      'What historiographical significance does Grundtvig\'s movement hold regarding resistance to German cultural hegemony?',
      [
        'Countered Prussian pressure',
        'Grundtvig promoted German culture',
        'The movement had no cultural impact',
        'Grundtvig was a Prussian agent',
      ],
      0,
      'Grundtvig emphasized Danish language and folklore as countermeasures to German cultural-political pressure.',
    ],
    [
      'How did the 1864 Schleswig-Holstein defeat catalyze constitutional revisions and generational political fractures?',
      [
        'Radicalized suffrage debates',
        'The war was inconsequential',
        'Denmark won the 1864 war',
        'There were no constitutional revisions',
      ],
      0,
      '1864 defeat shattered Danish power assumptions. Constitutional revisions reflected new identity anxieties.',
    ],
    [
      'What role did the cooperative movement (andelsbevaegelsen) play in Danish agrarian modernization?',
      [
        'Pooled capital for export',
        'Cooperatives were entirely absent',
        'They strengthened feudalism',
        'They caused agricultural collapse',
      ],
      0,
      'The cooperative movement enabled small farmers to collectively export dairy and grains. Cooperatives anchored agrarian success.',
    ],
    [
      'How did the 1945–1950 settlement of North Schleswig and exclusion of South Schleswig shape postwar Danish identity?',
      [
        'N. Schleswig back; South stayed German',
        'Denmark regained all Schleswig territories',
        'Schleswig was ceded to Sweden',
        'There was no postwar settlement',
      ],
      0,
      'The 1945 settlement returned North Schleswig. South Schleswig remained German, embodying failed 1864 revisionism.',
    ],
    [
      'What historiographical debate surrounds Denmark\'s WWII occupation regarding Jewish persecution and rescue?',
      [
        'Pragmatism or complicity in the rescue record',
        'There is universal consensus Denmark was innocent',
        'Denmark actively persecuted Jews',
        'No collaboration occurred whatsoever',
      ],
      0,
      'Scholarship debates occupation strategy. Most Jews were rescued, suggesting pragmatic resistance versus complicity.',
    ],
    [
      'How did the 1933 Kanslergade coalition reshape Danish labor law, wages, and welfare transition?',
      [
        'Minimum wages and unemployment insurance',
        'The agreement abolished worker protections',
        'It strengthened landlord feudalism',
        'There was no 1933 agreement',
      ],
      0,
      'The 1933 Kanslergade Agreement legislated labor standards. This cross-class coalition pioneered the Nordic model.',
    ],
    [
      'How did "folkestyre" (popular rule) ideology compete with monarchical sovereignty in shaping constitutional settlements?',
      [
        'Expanded suffrage, cut veto',
        'Folkestyre had no impact',
        'The monarchy became more absolute',
        'Folkestyre rejected democracy',
      ],
      0,
      'Grundtvigian and social democratic "folkestyre" pushed parliamentary democracy against monarchy. The 1953 Constitution established supremacy.',
    ],
    [
      'How did Denmark\'s 1973 EC entry reshape agricultural policy, regional identity, and welfare consensus?',
      [
        'CAP exposure forced welfare adaptations',
        'Denmark rejected European integration',
        'The EEC dissolved after Danish entry',
        'Agriculture benefited with zero adaptation',
      ],
      0,
      'EC entry exposed Danish agriculture to CAP but subsidized exports. Welfare adaptations balanced European integration with universalism.',
    ],
    [
      'How did postwar institutionalized labor-capital-state negotiations create the basis of Danish corporatism?',
      [
        'Negotiated consensus, few strikes',
        'No compromise existed',
        'Denmark endured constant labor violence',
        'Corporatism was rejected',
      ],
      0,
      'Postwar negotiations between labor, capital, and state produced consensus policies and low strike rates.',
    ],
    [
      'How do debates over Danish welfare "universalism" versus "selectivism" diverge from Beveridge and Bismarckian models?',
      [
        'Rejected means-testing',
        'Denmark adopted Beveridge entirely',
        'Denmark copied Bismarck directly',
        'Denmark had no welfare architecture',
      ],
      0,
      'Danish welfare emphasizes universal coverage without means-testing, differing from both British and Continental models.',
    ],
    [
      'What historiographical revisions since the 1990s challenge postwar narratives of Danish resistance to occupation?',
      [
        'Limited armed resistance',
        'Postwar accounts were completely accurate',
        'Denmark waged constant armed war',
        'No resistance occurred whatsoever',
      ],
      0,
      'Recent scholarship contests heroic resistance myths, emphasizing state accommodation and limited armed resistance.',
    ],
  ],
  professor: [
    [
      'How do recent historiographical reassessments of the Kalmar Union challenge teleological "Danish dominance" narratives through prosopographical analysis?',
      [
        'Consensual tri-lateral governance',
        'The union was always purely Danish-controlled',
        'Recent historians reject all primary sources',
        'The Kalmar Union never actually existed',
      ],
      0,
      'Revisionist scholarship shows the Kalmar Union involved negotiated tri-lateral governance and shared nobility—not unilateral rule.',
    ],
    [
      'What historiographical debate persists regarding the Øresund toll as "feudal rent" versus genuine sovereign maritime taxation?',
      [
        'Sovereign right or monopoly rent',
        'The toll was always free passage',
        'No toll ever existed',
        'Economists universally agree it was fair',
      ],
      0,
      'Scholars debate whether sundetold was legitimate taxation or monopoly extraction. The question illuminates medieval sovereignty.',
    ],
    [
      'How do prosopographical databases of Rigsråd membership (1380–1660) reveal factional competition constraining royal authority?',
      [
        'Noble blocs curbed absolutism',
        'The nobility had no power',
        'All nobles were unified',
        'Noble genealogies are irrelevant',
      ],
      0,
      'Prosopographical research reveals competing noble factions and kinship blocs constraining monarchy before 1660.',
    ],
    [
      'What revisionist interpretations of the 1660 Kongelov emphasize contingency over intrinsic legitimacy?',
      [
        'Fiscal crisis, noble coalitions',
        'The Kongelov was inevitable and popular',
        'No contingency factors existed',
        'The king had always been absolute',
      ],
      0,
      'Revisionist work argues the 1660 coup weaponized fiscal crisis and anti-aristocratic sentiment rather than inevitable absolutism.',
    ],
    [
      'How do quantitative studies of mantalslister (population registers) reveal uneven regional inequality within agrarian "improvement" narratives?',
      [
        'Wealth clustering, landlessness',
        'The registers show perfect equality',
        'All peasants became wealthy equally',
        'No regional variation existed',
      ],
      0,
      'Quantitative studies reveal persistent regional inequality and landlessness despite "improvement" narratives.',
    ],
    [
      'What historiographical tensions exist between celebrating Grundtvig as a progressive pedagogue versus critiquing nationalist ethnicism?',
      [
        'Democratization vs ethnicism',
        'All historians unanimously praise Grundtvig',
        'Grundtvig had no nationalist ideology',
        'Folk schools had no impact',
      ],
      0,
      'Scholarship questions whether Grundtvig\'s pedagogy represented democratization or ethnic nationalism.',
    ],
    [
      'How do postcolonial reassessments of Danish West African, Caribbean, and Asian activity complicate "peaceful nation" narratives?',
      [
        'Slave trading and colonial extraction',
        'Denmark never engaged in colonialism',
        'Danish colonies were entirely benevolent',
        'Colonial exploitation is irrelevant',
      ],
      0,
      'Postcolonial work reveals Danish slave trading and colonial extraction, complicating the "peaceful Denmark" narrative.',
    ],
    [
      'What historiographical debate frames the 1933 Kanslergade Agreement as tripartite corporatism versus crisis-driven coalition?',
      [
        'Corporatism or crisis bargaining',
        'The agreement was a democratic revolution',
        'No bargaining occurred',
        'The agreement had no political significance',
      ],
      0,
      'Historians debate whether 1933 reflects corporatist institutionalization or crisis-driven coalition-making.',
    ],
    [
      'How do recent accounts of Denmark\'s WWII occupation challenge postwar "resistance mythology" while engaging Holocaust debates?',
      [
        'Nuanced resistance, more accommodation',
        'Postwar accounts were entirely accurate',
        'Denmark actively participated in the Holocaust',
        'No historiographical revision occurred',
      ],
      0,
      'Revisionist work contests postwar myths, highlighting state accommodation while contextualizing Jewish rescue as contingent.',
    ],
    [
      'What do microeconomic analyses of the cooperative movement reveal about risk-pooling beyond simplistic "Danish Model" narratives?',
      [
        'Solved transaction costs via networks',
        'Cooperatives had no economic function',
        'All cooperatives were equally successful',
        'Farmers had no agency in creation',
      ],
      0,
      'Microeconomic analyses reveal how cooperatives addressed transaction costs. Regional and sectoral variation is pronounced.',
    ],
    [
      'How do the 1849 Grundloven and 1953 constitutional rewrite reflect divergent conceptions of monarchical sovereignty?',
      [
        '1849 balanced power; 1953 went unicameral',
        'Both constitutions were identical',
        'The 1953 revision strengthened monarchy',
        'Constitutional courts were invented in 1953',
      ],
      0,
      '1849 balanced monarchy and parliament; 1953 established parliamentary supremacy via unicameral Folketing.',
    ],
    [
      'What historiographical debates persist regarding Nordic welfare as "class compromise" versus "social democratic hegemony"?',
      [
        'Compromise or hegemony, contested',
        'There is universal agreement on welfare origins',
        'No class conflict shaped welfare',
        'Welfare states emerged spontaneously',
      ],
      0,
      'Historians debate whether Nordic welfare reflects negotiated compromise or social democratic hegemony.',
    ],
    [
      'How do quantitative studies of the "great leveling" (1960s–1980s) using tax records interrogate both egalitarian claims and persistent divides?',
      [
        'Income compression, persistent gender gaps',
        'Income inequality increased steadily',
        'Gender and regional divides disappeared entirely',
        'Tax records are unreliable sources',
      ],
      0,
      'Quantitative studies reveal substantial income compression alongside persistent gender and regional divides.',
    ],
    [
      'What role does the "Danish exceptionalism" framing play in welfare-state theory, and does it advance or constrain analysis?',
      [
        'Risks obscuring shared pressures',
        'Denmark is objectively unique',
        'Comparative analysis is impossible',
        'Welfare states are incomparable',
      ],
      0,
      'Critics argue "exceptionalism" frameworks obscure contingency. Relational analysis may better explain Nordic outcomes.',
    ],
    [
      'How do archival studies of 1973 EC entry negotiations reveal tension between agricultural goals and fiscal sovereignty?',
      [
        'Prioritized CAP access over sovereignty',
        'Denmark wanted isolation',
        'EC entry was entirely voluntary and costless',
        'No archival evidence exists',
      ],
      0,
      'Archival work shows Danish 1973 EC entry prioritized CAP access and fiscal transfers over sovereignty.',
    ],
  ],
};
